import request from '../../requests/requests';
import { Api } from '../../config/api';
import { configs } from '../../config/config';

export function importFinance(data){
    return request({
        url:Api.finance.upload,
        method:configs.http.request.methodPost,
        data
    })
}

export function seachImportFinance(data){
    return request({
        url:Api.search.list,
        method:configs.http.request.methodPost,
        data
    })
}




